import 'bootstrap';

// protect against double loading (caused by lodash-es for some reason)
if (!window.mainIndexLoaded) {
    window.mainIndexLoaded = true;

    // load for all normal pages
    if (document.querySelector('body.Page')) {
        import('./color-mode-switcher').then();
        import('./scroll-hide').then();
        import('./mobile-nav').then();
        // import('./vh').then();
        // import('./search-helper').then();
        // import('./dialog').then();
    }
    
    // animate-on-visible
    if (document.querySelector('[data-animate-on-visible]')) {
        import('./animate-on-visible').then();
    }
    
    // counterup-helper
    if (document.querySelector('[data-counterup]')) {
        import('./counterup-helper').then();
    }

    // tab-list
    if (document.querySelector('[data-element="tab-list"]')) {
        import('./tab-list').then();
    }
    
    // location-tabs
    if (document.querySelector('[data-element="location-tabs"]')) {
        import('./location-tabs').then();
    }

    // location-search
    if (document.querySelector('[data-element="location-search"]')) {
        import('./location-search').then();
    }

    // testimonial-slider
    if (document.querySelector('[data-behavior="slider"]')) {
        import('./testimonial-slider').then();
    }

    // promo-clickable
    if (document.querySelector('.element-promo .stretched-link')) {
        import('./promo-clickable').then();
    }

    // wechat-qr
    if (document.getElementById('wechatQRToggle')) {
        import('./wechat-qr').then();
    }

    // content-tooltip (TinyMCE editor tooltips)
    if (document.querySelector('[data-bs-toggle="tooltip"]')) {
        import('./content-tooltip').then();
    }

    // // focuspoint-helper
    // if (document.querySelector('[data-focus-x]')) {
    //     import('./focuspoint-helper').then();
    // }
}    
